import { Injectable } from '@angular/core';
import { Provider } from '../provider';
import { IFormField } from 'src/app/models/form.model';

@Injectable()
export class FormFieldService extends Provider<IFormField> {
  protected url = "forms/fields";
}
